import { render, staticRenderFns } from "./PBRInterfaceList.vue?vue&type=template&id=422e07b8&"
import script from "./PBRInterfaceList.vue?vue&type=script&lang=js&"
export * from "./PBRInterfaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports